import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=3362c544&scoped=true&"
import script from "./NewsListing.vue?vue&type=script&lang=js&"
export * from "./NewsListing.vue?vue&type=script&lang=js&"
import style0 from "./NewsListing.vue?vue&type=style&index=0&id=3362c544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362c544",
  null
  
)

export default component.exports